export default "__VITE_ASSET__a05d7858__"